import React from 'react';
import { useTranslate } from 'react-translate';
import Divider from './Divider';

const Footer = () => {
  const t = useTranslate('Footer');

  return (
    <footer className='pb-10 pt-4'>
      <div className='section-shell'>
        <Divider className='mb-6' />
        <div className='flex flex-col items-center justify-between gap-3 text-center text-sm text-[var(--text-soft)] md:flex-row md:text-left'>
          <p className='flex items-center gap-2 text-base font-extrabold tracking-[0.14em] text-[var(--text-soft)]'>
            <span className='brand-dot'></span>
            RAULWEBDEV
          </p>
          <p>{t('copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
